import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, CircularProgress } from '@mui/material';
import { useState } from 'react';

import { checkDev, getEnv } from '../../config';
import { useRefreshAppSetting } from '../../hooks/useRefreshAppSetting';
import { envBadge } from '../../utils/envBadge';
import { ConfirmPopup } from '../Popup/ConfirmPopup';

const envLabel = () => envBadge(getEnv(), checkDev()).label;

export const RefreshSettingsButton = () => {
	const { refresh, loading } = useRefreshAppSetting();
	const [confirmOpen, setConfirmOpen] = useState(false);
	const label = envLabel();

	return (
		<>
			<Button
				variant="contained"
				startIcon={loading ? <CircularProgress color="inherit" size={18} /> : <RefreshIcon />}
				disabled={loading}
				onClick={() => setConfirmOpen(true)}
				// 標題列是深色底，用白底深色字讓這個影響整個環境的操作一眼就看得到
				sx={{
					whiteSpace: 'nowrap',
					fontWeight: 700,
					bgcolor: 'common.white',
					color: 'primary.main',
					'&:hover': { bgcolor: 'grey.200' },
					'&.Mui-disabled': { bgcolor: 'grey.300', color: 'text.disabled' },
				}}
			>
				Refresh Settings
			</Button>
			<ConfirmPopup
				open={confirmOpen}
				setOpen={setConfirmOpen}
				action={refresh}
				title={`Refresh settings on ${label}?`}
				message={`This reloads the app settings of the ${label} environment (${window.location.hostname}).`}
				confirmText={`Refresh ${label} settings`}
			/>
		</>
	);
};
